import { BankAccountLiteModel, BankAccountModel } from 'api-hooks/bank-account';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { TransactionCategoryLiteModel } from 'api-hooks/transaction-category';
import { Expose, Type } from 'class-transformer';
import { TransactionalStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export enum bankTransactionTypeEnum {
  debit = 'debit',
  credit = 'credit',
}

class CommonBankTransactionModel extends CommonModel {
  code: string;
  status: TransactionalStatusEnum;
  type: string;
  description: string;
  number: string;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'transaction_category' })
  @Type(() => TransactionCategoryLiteModel)
  transactionCategory: TransactionCategoryLiteModel | null;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class BankTransactionLiteModel extends CommonBankTransactionModel {
  @Expose({ name: 'bank_account' })
  @Type(() => BankAccountLiteModel)
  bankAccount: BankAccountLiteModel;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class BankTransactionModel extends CommonBankTransactionModel {
  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'bank_account' })
  @Type(() => BankAccountModel)
  bankAccount: BankAccountModel;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class getBankTransactionsInput {
  params: CommonParamInput;
}

export class getBankTransactionInput {
  id: string;
}

export class BankTransactionMutationInput {
  transactionAt: Date;
  bankAccountId: string;
  needApproval: boolean;
  transactionCategoryId: string | null;

  type: string;
  amount: number;
  description: string;
}

export class BankTransactionUpdateInput {
  bankTransactionId: string;
  body: BankTransactionMutationInput;
}

export class BankTransactionDeleteInput {
  bankTransactionId: string;
}
